// extracted by mini-css-extract-plugin
export var footer = "_sh-0";
export var inherit = "_sh-1";
export var input = "_sh-2";
export var modalContent = "_sh-3";
export var quillEditor = "_sh-4";
export var subtitle = "_sh-5";